import React from 'react';

import { useSelector } from 'react-redux';

import Style from '../Header.module.css';

import { Button } from '../../../atoms';

import { pushEventInLoggy } from '../../../../utils/loggy';

function HeaderInfoWeb() {
  const { my_profile } = useSelector((state) => state);

  const handleEventTrigger = () => {
    pushEventInLoggy(
      {
        event: 'Reffer_via_WA_Browse_Job',
        page_name: 'Browse Job'
      },
      my_profile
    );
  };

  return (
    <div className={Style.headerContainer1}>
      <div className='container'>
        <div className='row margin-0'>
          <div className='col-6 padding0 relative-position'>
            <div className={Style.headerText1}>
              {my_profile?.data?.data ? <div>Hi {my_profile?.data?.data?.first_name} !</div> : null}
              Discover abundant job opportunities and enhance your productivity.
            </div>
          </div>
          <div className={`col-6 padding0 ${Style.flexStyleEnd}`}>
            <div className={Style.referBox}>
              <div className={Style.referBoxText}>
                Refer your friend to Awign Expert & Earn INR <span>40,000</span> for each selection
                <a href='https://wa.me/919164277011?text=Refer%20and%20earn' onClick={handleEventTrigger}>
                  <Button className='whatsapp-btn'>Refer via Whatsapp</Button>
                </a>
              </div>
            </div>
            <div className={Style.headerImg}>
              <img src='/images/header-images/Cycling.svg' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeaderInfoWeb;
